import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { DashboardLayout } from '@/components/layout/dashboard-layout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, Loader2 } from 'lucide-react';

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [processing, setProcessing] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      capturePayment();
    }
  }, [token]);

  const capturePayment = async () => {
    try {
      const response = await fetch('/api/paypal/capture-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });

      const data = await response.json();

      if (data.success) {
        setProcessing(false);
      } else {
        setError('Impossibile completare il pagamento');
        setProcessing(false);
      }
    } catch (error) {
      setError('Errore durante il completamento del pagamento');
      setProcessing(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="flex items-center justify-center min-h-[60vh]">
        <Card className="w-full max-w-md">
          <CardHeader className="text-center">
            {processing ? (
              <>
                <div className="flex justify-center mb-4">
                  <Loader2 className="w-16 h-16 text-blue-600 animate-spin" />
                </div>
                <CardTitle>Elaborazione pagamento...</CardTitle>
                <CardDescription>
                  Stiamo completando la tua iscrizione
                </CardDescription>
              </>
            ) : error ? (
              <>
                <CardTitle className="text-red-600">Errore</CardTitle>
                <CardDescription>{error}</CardDescription>
              </>
            ) : (
              <>
                <div className="flex justify-center mb-4">
                  <CheckCircle className="w-16 h-16 text-green-600" />
                </div>
                <CardTitle className="text-green-600">Pagamento completato!</CardTitle>
                <CardDescription>
                  Ti sei iscritto con successo al corso
                </CardDescription>
              </>
            )}
          </CardHeader>
          <CardContent className="space-y-3">
            {!processing && (
              <>
                <Link to="/dashboard/my-learning">
                  <Button className="w-full">
                    Vai ai miei corsi
                  </Button>
                </Link>
                <Link to="/dashboard/calendar">
                  <Button variant="outline" className="w-full">
                    Torna al calendario
                  </Button>
                </Link>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}
